<template>
  <div>
    <div class="title-block">窓際の指定</div>
    <p class="text-block">※指定しても予約できない場合があります</p>

    <div class="column">
      <div class="radio-wrap-vertical">
        <div class="radio">
          <input
            id="radio-3"
            v-model="windowSpecificationRadio"
            name="radio2"
            type="radio"
            :value="{ id: 0, label: '通路側を優先' }"
          />
          <label for="radio-3" class="radio-label">通路側を優先</label>
        </div>
        <div class="radio">
          <input
            id="radio-4"
            v-model="windowSpecificationRadio"
            name="radio2"
            type="radio"
            :value="{ id: 6, label: '窓側を優先' }"
          />
          <label for="radio-4" class="radio-label">窓側を優先</label>
        </div>
        <div class="radio">
          <input
            id="radio-5"
            v-model="windowSpecificationRadio"
            name="radio2"
            type="radio"
            :value="{ id: 4, label: '窓側が取れない場合予約しない' }"
          />
          <label for="radio-5" class="radio-label"
            >窓側が取れない場合予約しない</label
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";
import { useVModel } from "vue-composable";

export default {
  name: "MFITTBookingWindowSpecification",
  props: {
    windowSpecificationRadio: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const windowSpecificationRadio = useVModel(
      props,
      "windowSpecificationRadio"
    );

    return {
      windowSpecificationRadio,
    };
  },
};
</script>

<style lang="scss" scoped>
.title-block {
  margin: 20px 6px 8px;
  font-size: 13px;
  text-align: left;
  line-height: 17px;
  font-weight: bold;
}

.text-block {
  margin: 10px 6px;
  font-size: 12px;
  color: #ed2323;
}

.column .error-block {
  margin: 10px 0;
  font-size: 13px;
  font-weight: bold;
  text-align: right;
  line-height: 17px;
  color: #ff3333;
}

.column {
  margin-bottom: 16px;
  margin-top: 0;
}

/* ラジオボタン */
.radio-wrap {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin: 0 5px;
}
.radio-wrap {
  justify-content: space-between;
}
.radio {
  margin: 0.5rem !important;
}
.radio input[type="radio"] {
  position: absolute;
  opacity: 0;
}
.radio input[type="radio"] + .radio-label:before {
  content: "";
  background: #f4f4f4;
  border-radius: 100%;
  border: 1px solid #b4b4b4;
  display: inline-block;
  width: 1.4em;
  height: 1.4em;
  position: relative;
  top: -0.2em;
  margin-right: 1em;
  vertical-align: top;
  cursor: pointer;
  text-align: center;
  transition: all 250ms ease;
}
.radio input[type="radio"]:checked + .radio-label:before {
  background-color: #ff7600;
  box-shadow: inset 0 0 0 4px #f4f4f4;
}
.radio input[type="radio"]:focus + .radio-label:before {
  outline: none;
  border-color: #ff7600;
}
.radio input[type="radio"]:disabled + .radio-label:before {
  box-shadow: inset 0 0 0 4px #f4f4f4;
  border-color: #b4b4b4;
  background: #b4b4b4;
}
.radio input[type="radio"] + .radio-label:empty:before {
  margin-right: 0;
}

.radio-wrap.two-side {
  justify-content: flex-start;
}
.radio-wrap.two-side .radio {
  width: calc(50% - 1rem);
}
</style>
